import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "wrapper-general-error" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("img", {
      src: "https://av-studio-bucket.s3.us-east-1.amazonaws.com/iterrabyte/icons/404.svg",
      class: "icon",
      alt: "Error 404"
    }, null, -1),
    _createElementVNode("p", { class: "text" }, "Página no encontrada", -1),
    _createElementVNode("img", {
      src: "https://av-studio-bucket.s3.us-east-1.amazonaws.com/iterrabyte/logos/LogoColors.svg",
      class: "logo",
      alt: "iterrabyte"
    }, null, -1)
  ])))
}